export default __webpack_public_path__ + "static/media/gwn15.5db55ea0.webp";